global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import AOS from 'aos';
import 'aos/dist/aos.css';
$(document).ready(function() {

    AOS.init({
        delay: 400,
        duration: 800,
        once: true,
    });

    if($('.headroom').length > 0){
        let headroomEl = document.querySelector("header");
        let options = {
            offset : 100,
        }
        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }
    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });

    let burgerButton = $('.burger-button');
    let exit = $('#exit');
    burgerButton.on('click', function(e) {
        e.preventDefault();
        toggleMenuOpenClose();
    });

    exit.on('click', function(e) {
        e.preventDefault();
        toggleMenuOpenClose();
    });

    function toggleMenuOpenClose() {
        let body = $('body');
        let headerNavWrapper = $('#mobile-menu');
        if (headerNavWrapper.hasClass('open')) {
            body.removeClass('no-scroll-y');
            headerNavWrapper.removeClass('open');
            burgerButton.show();
            exit.hide();
        } else {
            body.addClass('no-scroll-y');
            headerNavWrapper.addClass('open');
            burgerButton.hide();
            exit.show();

        }
        // $('#burger-button i').toggleClass("fa-bars fa-x");
    }

    let pageline = $('.pageline');
    let footer = $('footer');
    let pagelineDown = false
    let bottom = $('footer').height();
    $(window).scroll(function () {
        if (pageline) {
            if ($(window).scrollTop() >= footer.offset().top - window.innerHeight && pagelineDown === false) {
                pagelineDown = true;
                pageline.addClass('position-absolute').css('bottom', bottom - 20);
                // alert('You reached the end of the DIV');
            } else if ($(window).scrollTop() < footer.offset().top - window.innerHeight && pagelineDown === true) {
                pagelineDown = false;
                pageline.removeClass('position-absolute').css('bottom', '-20px');
            }
        }

    });
});
